import SimpleLightbox from 'simple-lightbox';
import $ from 'jquery';

$('.wp-block-image img').each( function(idx,img) {
    var pTitle = img.title;
    $($(img).parent('.wp-block-image a')).attr('title',pTitle);
});

$('.wp-block-image a').simpleLightbox({
	nav: false,
	showCaptions: false,
});